import { render } from "./tcedit.vue?vue&type=template&id=79b1c68b&scoped=true"
import script from "./tcedit.vue?vue&type=script&lang=js"
export * from "./tcedit.vue?vue&type=script&lang=js"

import "./tcedit.vue?vue&type=style&index=0&id=79b1c68b&lang=scss&scoped=true"
import "./tcedit.vue?vue&type=style&index=1&id=79b1c68b&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b1c68b"]])

export default __exports__